export default __webpack_public_path__ + "static/media/u_comment.f7889110.svg";